// React
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
// Routing
import { Route, Switch, withRouter } from "react-router-dom";
// Infrastructure
// Components
import { Step, StepLabel, Stepper } from "@material-ui/core";
// Translations
import { withTranslation } from "react-i18next";
import { ReactFlowProvider } from "reactflow";
// Svg
import { arrowLeftSvg } from "@assets";
// Styles
import "views/Bots/NLP/styles/index.scss";
import Build from "./Build";
import Share from "./Share";
import ProjectWebInterface from "./Design";
import { updateFilters } from "vendor/application/disptach";
// Amplitude API
import { AmplitudeAPI } from "@api/Amplitude";
import { showNotify } from "vendor/application/disptach";
// Components

import FlowActionsButtons from "./Build/Flow/components/FlowActionsButtons";
import FlowTabs from "./Build/Flow/components/FlowTabs";
import { ElementsHandleV2 } from "vendor/application/handleMethodsV2";
import { FlowNodesProvider } from "./Build/Flow/context/FlowNodesProvider";
import { IntegrationsAPI } from "api/application/Integrations";
import { returnElementFromArray } from "vendor/application";
import { IntentsAPI } from "./Build/Tabs/Intents/infrastructure";
import { get_users } from "api/application/Users";
import Flow from "./Build/Flow";
import { SidebarProvider } from "./Build/Flow/components/SidebarFlow/context";
import SidebarFlow from "./Build/Flow/components/SidebarFlow";

const StepConnector = () => {
  return arrowLeftSvg();
};

class NLP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      activeStep: 0,
      project: false,
      currentNodes: [],
      currentEdges: [],
      isLoading: false,
      hasDescripcion: false,
      hasEntradas: false,
      hasRespuestas: false,
      hasExtensions: false,
      hasParams: false,
      hasDefaultResponse: false,
      variables: [],
      use_custom_fields: false,
      integrations: [],
      settings: {
        tags: "",
        tags_hours_control: "",
        tags_individual: "",
        tags_campaign: "",
      },
      zendesk_groups: false,
      switchboard: null,
    };
  }

  componentDidMount = () => {
    const { match, history, project } = this.props;
    const isFlowAction = window.location.search.includes("action=flow");
    let step;
    switch (match.params.action) {
      case "design":
        step = 1;
        break;
      case "share":
        step = 2;
        break;
      case "build":
        step = 0;
        break;
      default:
        history.push(`/${project}/nlp/build`);
        step = 0;
        break;
    }

    this.setState({ activeStep: step });
    this.activeProject(this.props.data.actualProject);

    if (isFlowAction) {
      this.handleTabs();
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const id = urlParams.get("id");
      if (!id) return;
      this.handleAmplitude("Enter to existing intent");
      this.getIntent();
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.handleTabs();
      this.handleAmplitude("Enter to existing intent");
      this.getIntent();
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { actualProject, filters } = this.props.data,
      nextActualProject = nextProps.data.actualProject;
    if (nextActualProject.id !== actualProject.id) {
      filters.intents.pagination.page = 1;
      filters.intents.search = "";
      filters.intents.context_selector.id = "";
      filters.intents.context_selector.name = "";
      this.props.dispatch(updateFilters(filters));
    }
  };

  handleNodesUpdate = (nodes) => {
    this.setState({ currentNodes: nodes });
  };
  handleEdgesUpdate = (edges) => {
    this.setState({ currentEdges: edges });
  };

  updateIntent = (newIntentOrUpdater) => {
    this.setState((prevState) => {
      const newIntent =
        typeof newIntentOrUpdater === "function"
          ? newIntentOrUpdater(prevState.intent)
          : newIntentOrUpdater;
      return { intent: newIntent };
    });
  };

  updateVariables = (new_variables) => {
    this.setState({ variables: new_variables });
  };

  updateContexts = (new_contexts) => {
    this.setState({ contexts: new_contexts });
  };

  activeProject = (project) => {
    const { history } = this.props;
    if (!project.active) {
      history.push(`/${project.id}/stats`);
    }
  };
  updateIntegrations = (int) => {
    if (this && this.setState) {
      this.setState({ integrations: int });
    } else {
    }
  };
  removeInvalidZendeskDeskIds = (variablesDesk = [], integrations = []) => {
    const zendeskIntegration = integrations.find(
      (int) => int.channel === "zendesk_full"
    );
    const validDeskIds =
      zendeskIntegration?.multiple?.map((desk) => desk.id) || [];

    return variablesDesk.map((variable) => {
      const deskId = variable?.zendesk_ticket_field?.desk_id;
      const isInvalidDesk = deskId && !validDeskIds.includes(deskId);

      if (isInvalidDesk) {
        return {
          ...variable,
          zendesk_ticket_field: {
            desk_id: null,
            id: null,
            title: "",
            type: "",
            equivalences: [],
            custom_field_options: [],
            custom_field_options_actual: [],
          },
        };
      }

      return variable;
    });
  };

  handleZendesk = (zendesk_full, intent) => {
    if (zendesk_full?.active) {
      if (intent.desks?.name === "zendesk_full") {
        if (intent.desks.info.desk_id) {
          this.getGroups(intent.desks.info.desk_id);
        } else {
          if (zendesk_full.multiple.length > 1) {
            let is_default = zendesk_full.multiple.find(
              (int) => int.is_default
            );
            intent.desks.info.desk_id = is_default.id;
            this.getGroups(is_default.id);
          } else if (zendesk_full.multiple.length === 1) {
            intent.desks.info.desk_id = zendesk_full.multiple[0].id;
            this.getGroups(zendesk_full.multiple[0].id);
          }
        }
      }
      this.handleZendeskParameters(zendesk_full.multiple, intent);
      this.handleZendeskExtensions(zendesk_full.multiple, intent);
    }
  };

  handleSunco = (sunco, intent) => {
    if (sunco?.info?.zendesk?.use_custom_fields?.active) {
      this.getCustomFields("sunco", sunco.id, intent);
    }
    if (sunco?.active && sunco?.info?.switchboard.updated) {
      this.getSwitchboard(sunco);
    }
  };

  handleChatGPT = (chatgpt, intent) => {
    if (chatgpt?.active) {
      intent.desks.info.max_tokens = chatgpt.info.max_tokens;
      intent.desks.info.max_interactions =
        chatgpt.info.back_to_bot.max_interactions;
    }
  };

  handleCentridesk = (centridesk) => {
    if (centridesk) {
      this.getUsers();
    }
  };

  getIntegrations = async (intent) => {
    const { access, actualProject, limitsIntegrations } = this.props.data;
    try {
      const obj = new IntegrationsAPI(actualProject.id, access, this.props);
      const res = await obj.get_integrations();
      let integrations = [];
      res.forEach((integration) => {
        const exist = integrations.filter(
          (int) => int.channel === integration.channel
        );
        if (
          [
            "zendesk_full",
            "zendesk_chat",
            "centridesk",
            "sunco",
            "gpt-3",
          ].includes(integration.channel) &&
          exist.length <= 0
        ) {
          if (limitsIntegrations[integration.channel]?.multiple) {
            let multiple = res.filter(
              (int) => int.channel === integration.channel
            );
            if (multiple.length > 0) {
              integration.multiple = [];
              multiple.forEach((m) =>
                integration.multiple.push({
                  id: m.id,
                  name: m.name ?? m.channel,
                  use_custom_fields: m.info.use_custom_fields,
                  is_default: m.is_default,
                })
              );
            }
          }
          integrations.push(integration);
        }
      });

      const switchboard = { updated: false, array: [] };

      const zendesk_full = integrations.find(
        (integration) => integration.channel === "zendesk_full"
      );
      const sunco = integrations.find(
        (integration) => integration.channel === "sunco"
      );
      const chatgpt = integrations.find(
        (integration) => integration.channel === "gpt-3"
      );
      const centridesk = integrations.find(
        (integration) => integration.channel === "centridesk"
      );

      this.handleZendesk(zendesk_full, intent);
      this.handleSunco(sunco, intent);
      this.handleChatGPT(chatgpt, intent);
      this.handleCentridesk(centridesk);

      if (sunco?.active && sunco?.info?.switchboard.updated) {
        switchboard.updated = true;
      }

      this.setState({ integrations: integrations, switchboard: switchboard });
      return integrations;
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  getUsers = async () => {
    get_users(this.props).then((users) => {
      this.setState({ users: users });
    });
  };

  getGroups = async (channel_id) => {
    const { access, actualProject } = this.props.data;
    try {
      const obj = new IntegrationsAPI(actualProject.id, access, this.props);
      const res = await obj.get_zendesk_groups(channel_id);
      this.setState({ zendesk_groups: res });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  getSwitchboard = async (sunco) => {
    const { actualProject, access } = this.props.data;
    try {
      const obj = new IntegrationsAPI(actualProject.id, access, this.props);
      const res = await obj.get_integration_switchboard_by_id(sunco.id);

      this.setState({ switchboard: { updated: true, array: res } });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  handleZendeskParameters = async (arr, intent) => {
    const custom_fields = arr?.filter((arr) => arr?.use_custom_fields);

    const customs = [];
    intent.parameters.forEach((param) => {
      const desk_id = param?.zendesk_ticket_field?.desk_id;
      if (desk_id && custom_fields.filter((el) => el.id === desk_id)[0]) {
        customs.push(desk_id);
      }
    });

    const channels_id = [...new Set(customs)];

    const request = [];
    if (channels_id.length > 0) {
      for (const channel_id of channels_id) {
        request.push(
          await this.getCustomFields("zendesk", channel_id, intent, false, true)
        );
      }
    }

    let use_custom_fields = false;
    request.forEach((el) => {
      if (!use_custom_fields) {
        use_custom_fields = {
          [el?.channel_id]: el?.custom_fields,
        };
      } else if (!use_custom_fields[el.channel_id]) {
        use_custom_fields[el.channel_id] = el.custom_fields;
      }
    });

    if (use_custom_fields) {
      this.setState({ use_custom_fields, intent: intent });
    }
  };

  handleZendeskExtensions = async (arr, intent) => {
    const custom_fields = arr?.filter((arr) => arr?.use_custom_fields);

    const customs = [];
    (intent?.extensions?.variables_desk || []).forEach((param) => {
      const desk_id = param?.zendesk_ticket_field?.desk_id;
      if (desk_id && custom_fields.filter((el) => el.id === desk_id)[0]) {
        customs.push(desk_id);
      }
    });

    const channels_id = [...new Set(customs)];

    const request = [];
    if (channels_id.length > 0) {
      for (const channel_id of channels_id) {
        request.push(
          await this.getCustomFields("zendesk", channel_id, intent, false, true)
        );
      }
    }

    let use_custom_fields = false;
    request.forEach((el) => {
      if (!use_custom_fields) {
        use_custom_fields = {
          [el?.channel_id]: el?.custom_fields,
        };
      } else if (!use_custom_fields[el.channel_id]) {
        use_custom_fields[el.channel_id] = el.custom_fields;
      }
    });

    if (use_custom_fields) {
      this.setState({
        use_custom_fields,
        use_custom_fields_duplicated: use_custom_fields,
        intent: intent,
      });
    }
  };

  getCustomFields = async (type, channel_id, intent, update, request) => {
    const { access, actualProject } = this.props.data;
    try {
      const obj = new IntegrationsAPI(actualProject.id, access, this.props);
      let custom_fields = await obj.custom_fields(channel_id);
      return await this.handleCustomFields(
        type,
        channel_id,
        custom_fields,
        intent,
        update,
        request
      );
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  getCustomFieldsCreate = async (type, channel_id) => {
    const { access, actualProject } = this.props.data;
    let { use_custom_fields } = this.state;
    try {
      const obj = new IntegrationsAPI(actualProject.id, access, this.props);
      const res = await obj.custom_fields(channel_id);

      if (!use_custom_fields) {
        use_custom_fields = {
          [channel_id]: res,
        };
      } else {
        use_custom_fields[channel_id] = res;
      }
      this.setState({ use_custom_fields: use_custom_fields });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };
  handleCustomFields = async (
    type,
    channel_id,
    custom_fields,
    intent,
    update,
    request
  ) => {
    let { use_custom_fields } = this.state;
    if (!update) {
      intent?.parameters.map((parameter, i) => {
        let zendesk = parameter.zendesk_ticket_field,
          element_custom_field = returnElementFromArray(
            zendesk?.id,
            custom_fields,
            "id"
          );

        if (zendesk?.id && zendesk.desk_id === channel_id) {
          zendesk = {
            id: zendesk.id,
            type: zendesk.type,
            title: `${element_custom_field?.title} ${
              element_custom_field?.regexp_for_validation
                ? `(${element_custom_field.regexp_for_validation})`
                : ""
            }`,
            equivalences: zendesk.equivalences,
            desk_id: zendesk.desk_id,
            custom_field_options:
              element_custom_field?.custom_field_options ?? [],
            custom_field_options_actual:
              element_custom_field?.custom_field_options
                ? JSON.parse(
                    JSON.stringify(element_custom_field?.custom_field_options)
                  )
                : [],
          };

          zendesk.equivalences.map((equivalence, equivalence_i) => {
            zendesk.custom_field_options_actual.map((custom, custom_i) => {
              if (equivalence.value === custom.value) {
                zendesk.equivalences[equivalence_i].title = custom.name;
                zendesk.custom_field_options_actual.splice(custom_i, 1);
              }
            });
          });

          intent.parameters[i].zendesk_ticket_field = zendesk;
        } else {
          zendesk = null;
        }
      });

      (intent?.extensions?.variables_desk || []).map((variable, i) => {
        let zendesk = variable.zendesk_ticket_field,
          element_custom_field = returnElementFromArray(
            zendesk?.id,
            custom_fields,
            "id"
          );

        if (zendesk?.id && zendesk.desk_id === channel_id) {
          zendesk = {
            id: zendesk.id,
            type: zendesk.type,
            title: `${element_custom_field?.title} ${
              element_custom_field?.regexp_for_validation
                ? `(${element_custom_field.regexp_for_validation})`
                : ""
            }`,
            equivalences: zendesk.equivalences,
            desk_id: zendesk.desk_id,
            custom_field_options:
              element_custom_field?.custom_field_options ?? [],
            custom_field_options_actual:
              element_custom_field?.custom_field_options
                ? JSON.parse(
                    JSON.stringify(element_custom_field?.custom_field_options)
                  )
                : [],
          };

          zendesk.equivalences.map((equivalence, equivalence_i) => {
            zendesk.custom_field_options_actual.map((custom, custom_i) => {
              if (equivalence.value === custom.value) {
                zendesk.equivalences[equivalence_i].title = custom.name;
                zendesk.custom_field_options_actual.splice(custom_i, 1);
              }
            });
          });

          intent.extensions.variables_desk[i].zendesk_ticket_field = zendesk;
        } else {
          zendesk = null;
        }
      });
    }

    if (request) {
      return { custom_fields, channel_id };
    } else {
      if (!use_custom_fields) {
        use_custom_fields = {
          [channel_id]: custom_fields,
        };
      } else {
        use_custom_fields[channel_id] = custom_fields;
      }
      this.handleVariables(intent);
      this.setState((prevState) => ({
        use_custom_fields: {
          ...use_custom_fields,
          ...prevState.use_custom_fields_duplicated,
        },
        use_custom_fields_duplicated: {
          ...use_custom_fields,
          ...prevState.use_custom_fields_duplicated,
        },
        intent: intent,
      }));
    }
  };

  handleVariables = (obj, integrations = this.state.integrations) => {
    const integrationZendesk = integrations.find(
      (int) => int.channel === "zendesk_full"
    );
    const extension = obj?.extensions;
    /**
     * @type {string[]}
     */
    const variables = extension?.variables || [];
    const equivalences = extension?.equivalences || {};
    /**
     * @type {import('types/zendesk').ZendeskVariable[]}
     */
    let variables_desk = extension?.variables_desk || [];
    if (integrationZendesk) {
      variables_desk = this.removeInvalidZendeskDeskIds(
        variables_desk,
        integrations
      );
    } else {
      variables_desk = extension?.variables_desk || [];
    }

    const ticketFieldByVariableName = new Map(
      (variables_desk || []).map((variable) => [
        variable.name,
        variable.zendesk_ticket_field,
      ])
    );
    /**
     * @type {import('types/ident').IdentVariable[]}
     */
    const newVariables = variables.map((element) => ({
      variable: element.substring(2),
      equivalence: equivalences[element]
        ? this.handleStartEquivalence(equivalences[element])
        : [],
      zendesk_ticket_field: ticketFieldByVariableName.get(element) || null,
    }));

    this.setState({
      // variables: newVariables,
    });
  };
  handleStartEquivalence = (equivalences) => {
    let obj = [];

    for (const [key, value] of Object.entries(equivalences)) {
      obj.push({ key: key, value: value });
    }

    return obj;
  };

  handleStep = (step) => {
    const { history } = this.props;
    const { user, device_id, actualProject } = this.props.data;
    const steps = ["build", "design", "share"];
    if (this.state.activeStep !== step) {
      new AmplitudeAPI({
        event_type: `Click on ${steps[step]}`,
        device_id: device_id,
        user_id: user.email,
      }).eventLog();

      this.setState({ activeStep: step });
      history.push(`/${actualProject?.id}/nlp/${steps[step]}`);
    }
  };

  goToIntentList = () => {
    const { history, data } = this.props;
    history.push(`/${data.actualProject.id}/nlp/build?tab=intents`);
    this.handleTabs?.();
  };

  handleTabs = () => {
    const { history } = this.props;
    const { empty, actualProject } = this.props.data;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const action = urlParams.get("action");
    let tab = urlParams.get("tab");
    const id = urlParams.get("id");

    if (empty) {
      const data = { message: "nlp_sidebar", severity: "error" };
      this.props.dispatch(showNotify(data));

      history.push(`/${actualProject.id}/chatbot`);
    } else {
      switch (tab) {
        case "intents":
          this.setState({ tabValue: 0 });
          break;
        case "contexts":
          this.setState({ tabValue: 1 });
          break;
        case "entities":
          this.setState({ tabValue: 2 });
          break;
        default:
          history.push(`${this.props.location.pathname}?tab=intents`);
          tab = "intents";
          this.setState({ tabValue: 0 });
          break;
      }
      this.setState({ tab: tab, action: action, id: id });
    }
  };
  setQuery = (e, to) => {
    e.preventDefault();
    this.props.history.push(`${this.props.location.pathname}?tab=${to}`);
    this.handleAmplitude(`Click on ${to}`);
    this.handleTabs();
  };
  handleAmplitude = (event_type) => {
    const { user, device_id } = this.props.data;
    new AmplitudeAPI({
      event_type: event_type,
      device_id: device_id,
      user_id: user.email,
    }).eventLog();
  };
  a11yProps(index) {
    return {
      id: `nlp-tab-${index}`,
      "aria-controls": `nlp-tabpanel-${index}`,
    };
  }

  openTestChat = (e) => {
    e.preventDefault();
    const { actualProject } = this.props.data;
    this.handleAmplitude("Test chatbot");
    window.open(
      `${process.env.PUBLIC_URL}/test_chat?project_id=${
        actualProject.id
      }&chat_id=${actualProject.chat_id || this.state.chat_id}`
    );
  };
  handleLimits = (type, action, intent) => {
    const { limits } = this.props.data;
    switch (action) {
      case "delete":
        switch (type) {
          case "responses":
          case "phrases":
            limits[type].total = limits[type].total - 1;
            limits.intents_create[`intents_${type}_total`] =
              limits.intents_create[`intents_${type}_total`] !== 0 &&
              limits.intents_create[`intents_${type}_total`] - 1;
            break;
        }
        break;
      case "add":
        break;
    }

    this.setState({ limits: limits, intent: intent });
  };

  deleteVariable = (i) => {
    let { variables_desk } = this.state.intent.extensions;

    this.state.variables.splice(i, 1);
    variables_desk?.splice(i, 1);

    this.updateVariables(this.state.variables);
    this.updateIntent(this.state.intent);
  };

  updateElement = (e, type, type_of, i) => {
    const { intent } = this.state;
    const obj = new ElementsHandleV2(
      intent,
      e?.target?.value,
      type,
      type_of,
      i
    );
    const res = obj.handleElement();

    if (type_of === "delete") {
      switch (type) {
        case "responses":
        case "phrases":
          this.handleLimits(type, "delete", res);
          break;
        case "extension":
          this.setState({ intent: res, variables: [] });
          break;
        case "conditional_responses":
        case "parameters":
          this.setState({ intent: res });
          break;
      }
    } else {
      if (res.is_default && res.phrases.length > 0) {
        res.phrases = [];
        this.setState({ limits: this.props.data.limits, intent: res });
      } else {
        this.setState({ intent: res });
      }
    }

    if (type?.includes("extension")) {
      e.stopPropagation();
    }
  };
  handleAddVariables = () => {
    let obj = [];

    this.state.variables.forEach((el) => {
      if (el.variable) {
        obj.push(`$.${el.variable}`);
      }
    });

    return obj;
  };

  handleEquivalence = (equivalences) => {
    let obj = {};

    equivalences.forEach((equivalence) => {
      obj = { [equivalence.key]: equivalence.value, ...obj };
    });

    return obj;
  };

  handleAddEquivalences = () => {
    let obj = {};
    const variables = this.state.variables;
    let value = {};
    variables.forEach((item, i) => {
      if (item.variable) {
        const element = `$.${item.variable}`;
        if (value) {
          obj = { [element]: this.handleEquivalence(item.equivalence), ...obj };
          this.state.variables[i].error = false;
          value = obj;
        } else {
          this.state.variables[i].error = true;
          value = false;

          this.props.dispatch(
            showNotify({
              message: "extension_equivalences_has_an_invalid_value",
              severity: "error",
            })
          );
        }
      } else {
        this.state.variables[i].error = true;
        value = false;

        this.props.dispatch(
          showNotify({
            message: "extension_variable_can_not_be_an_empty_string",
            severity: "error",
          })
        );
      }
    });

    this.setState((prevState) => ({
      variables: prevState.variables,
    }));

    return value;
  };

  handleTags = (e, type, elementType, chipToDelete, i) => {
    const { settings, intent } = this.state;
    let element_to_update;

    switch (elementType) {
      case "tags":
        element_to_update = intent?.tags ? intent.tags : [];
        break;
      default:
    }

    const tag = e.target.value;
    switch (type) {
      case "add":
        if (tag.match(/^[a-zA-Z0-9_\/]*$/)) {
          settings[elementType] = tag;
          this.setState({ settings: settings });
        }
        break;
      case "delete":
        element_to_update.forEach((el) => {
          if (el === chipToDelete) {
            element_to_update.splice(i, 1);
          }
        });
        this.setState({ intent: intent });
        break;
      case "enter":
        element_to_update.push(tag);
        settings[elementType] = "";
        this.setState({ intent: intent, settings: settings });
        break;
      default:
    }
  };

  getIntent = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get("id");
    if (!id) return;
    this.setState({ id: id });
    const { actualProject, access } = this.props.data;
    try {
      let obj = new IntentsAPI(actualProject.id, access, {
        ...this.props,
        id,
      });
      let intent = await obj.get_intent_by_id();

      this.getEvents(intent.id);

      const info = intent?.desks?.info;

      if (!info) {
        intent.desks = {
          info: {
            ticket_status: "new",
            zendesk_ticket_status: "new",
            zendesk_mode: "desk",
            centridesk_ticket_status: "new",
            centridesk_mode: "desk",
            group_id: null,
            max_tokens: 16,
            max_interactions: 1,
            desk_id: null,
          },
        };
      } else {
        const channel = intent.desks.name;
        const status = intent.desks.info.ticket_status;
        const mode = intent.desks.info.mode ?? "desk";

        intent.desks.info.zendesk_mode = "desk";
        intent.desks.info.centridesk_mode = "desk";
        intent.desks.info.zendesk_ticket_status = "new";
        intent.desks.info.centridesk_ticket_status = "new";

        if (!intent.desks.info.max_tokens) {
          intent.desks.info.max_tokens = 16;
          intent.desks.info.max_interactions = 1;
        }

        if (channel === "zendesk_full") {
          intent.desks.info.zendesk_ticket_status = status;
          intent.desks.info.zendesk_mode = mode;
        } else if (channel === "centridesk") {
          intent.desks.info.centridesk_ticket_status = status;
          intent.desks.info.centridesk_mode = mode;
        }
      }

      if (intent.extensions.auth) {
        if (!intent.extensions.auth?.headers) {
          intent.extensions.auth.headers = [];
        }
        intent.extensions.auth.access_key_input =
          intent.extensions.auth.access_key?.replaceAll("$.", "");
      }

      if (intent.conditional_responses) {
        intent.conditional_responses.forEach((conditional, i) => {
          if (!conditional.param0 && conditional.param1) {
            if (["$.sys_is_in_business_hours"].includes(conditional.param1)) {
              intent.conditional_responses[i].param0 =
                "$.sys_is_in_business_hours";
            } else {
              intent.conditional_responses[i].param0 = "custom";
            }
          }
        });
      }

      this.setState({ intent: intent });
      const integrations = await this.getIntegrations(intent);
      this.handleVariables(intent, integrations);
      this.getIntegrations(intent);
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));

      this.returnToList();
    }
  };

  getEvents = async (intent_id) => {
    const { access, actualProject } = this.props.data;
    try {
      const obj = new IntentsAPI(actualProject.id, access, this.props);
      const events = await obj.get_events();
      let events_arr = [];
      events.forEach((event) => {
        const new_events = [];
        if (event.id !== intent_id) {
          event.events.forEach((evt) => {
            new_events.push({
              intent_id: event.id,
              event: evt,
            });
          });

          const group_events = {
            group_name: event.name,
            items: new_events,
          };

          events_arr.push(group_events);
        }
      });

      this.setState({ events: events_arr });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  render() {
    const { actualProject, plan } = this.props.data;
    const { getLimits, t } = this.props;
    const { activeStep, tabValue, use_custom_fields } = this.state;
    const isFlowAction = window.location.search.includes("action=flow");
    return (
      actualProject && (
        <React.Fragment>
          <div className={"config_header normal"}>
            <span />
            {plan.plan.name !== "consulting_sunco" && (
              <div className={"config_header__steps"}>
                <Stepper connector={<StepConnector />} activeStep={activeStep}>
                  <Step onClick={() => this.handleStep(0)}>
                    <StepLabel>
                      {t("card.content.project.steps.build")}
                    </StepLabel>
                  </Step>
                  <Step onClick={() => this.handleStep(1)}>
                    <StepLabel>
                      {t("card.content.project.steps.design")}
                    </StepLabel>
                  </Step>
                  <Step onClick={() => this.handleStep(2)}>
                    <StepLabel>
                      {t("card.content.project.steps.share")}
                    </StepLabel>
                  </Step>
                </Stepper>
              </div>
            )}
            <div />
          </div>
          {isFlowAction && (
            <>
              <FlowTabs tabValue={tabValue} setQuery={this.setQuery} t={t} />
              <FlowActionsButtons
                t={t}
                id={this.state.id}
                isLoading={this.state.isLoading}
                setLoading={(value) => this.setState({ isLoading: value })}
                currentNodes={this.state.currentNodes}
                currentEdges={this.state.currentEdges}
                dispatch={this.props.dispatch}
                data={this.props.data}
                history={this.props.history}
                handleTabs={this.handleTabs}
                updateVariables={this.updateVariables}
                updateIntent={this.updateIntent}
                handleAddEquivalences={this.handleAddEquivalences}
                handleAddVariables={this.handleAddVariables}
                intent={this.state.intent}
                variables={this.state.variables}
              />
              <SidebarProvider>
                <div className="config_content config_content_flow">
                  <ReactFlowProvider>
                    <FlowNodesProvider>
                      <Flow
                        data={this.props.data}
                        handleTabs={this.handleTabs}
                        history={this.props.history}
                        i18n={this.props.i18n}
                        location={this.props.location}
                        match={this.props.match}
                        staticContext={this.props.staticContext}
                        tReady={this.props.tReady}
                        t={t}
                        id={this.state.id}
                        intent={this.state.intent}
                        actualProject={actualProject}
                        updateContexts={this.updateContexts}
                        updateIntent={this.updateIntent}
                        updateElement={this.updateElement}
                        limits={this.props.data.limits}
                        access={this.props.data.access}
                        dispatch={this.props.dispatch}
                        contexts={this.state.contexts}
                        limitsIntegrations={this.props.data.limitsIntegrations}
                        updateVariables={this.updateVariables}
                        variables={this.state.variables}
                        type={this.props.data.type}
                        updateUseCustomFields={this.updateUseCustomFields}
                        getCustomFields={this.getCustomFields}
                        use_custom_fields={use_custom_fields}
                        integrations={this.state.integrations}
                        updateIntegrations={this.updateIntegrations}
                        getCustomFieldsCreate={this.getCustomFieldsCreate}
                        deleteVariable={this.deleteVariable}
                        handleTags={this.handleTags}
                        settings={this.state.settings}
                        zendesk_groups={this.state.zendesk_groups}
                        getGroups={this.getGroups}
                        onNodesUpdate={this.handleNodesUpdate}
                        handleVariables={this.handleVariables}
                        onEdgesUpdate={this.handleEdgesUpdate}
                        integrationEdit={this.getIntegrations}
                      />
                    </FlowNodesProvider>
                  </ReactFlowProvider>
                  <SidebarFlow
                    hasDescripcion={this.state.hasDescripcion}
                    hasEntradas={this.state.hasEntradas}
                    hasRespuestas={this.state.hasRespuestas}
                    hasExtensions={this.state.hasExtensions}
                    hasParams={this.state.hasParams}
                    hasDefaultResponse={this.state.hasDefaultResponse}
                  />
                </div>
              </SidebarProvider>
            </>
          )}
          <div>
            <Switch>
              <Route path="/:project/nlp/build" exact>
                {!window.location.search.includes("action=flow") && (
                  <Build
                    getLimits={getLimits}
                    project={actualProject.id}
                    actualProject={actualProject}
                    handleTabs={this.handleTabs}
                  />
                )}
              </Route>
              <Route path="/:project/nlp/design" exact>
                <ProjectWebInterface
                  project_id={actualProject.id}
                  chat_id={actualProject.chat_id}
                />
              </Route>
              <Route path="/:project/nlp/share" exact>
                <Share
                  project_id={actualProject.id}
                  chat_id={actualProject.chat_id}
                />
              </Route>
            </Switch>
          </div>
        </React.Fragment>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state,
  };
};

const connect_nlp = connect(mapStateToProps)(NLP);
NLP.propTypes = {
  data: PropTypes.object.isRequired,
  getLimits: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  tReady: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  staticContext: PropTypes.object,
};
export default withTranslation("common")(withRouter(connect_nlp));
